/* Eleven Theory native scroll scenes.
 * Direct choreography port of the authored Home, Materials and Carry Forward HTML.
 * All content exists in Liquid before this optional enhancement starts.
 * Requires local gsap.min.js, ScrollTrigger.min.js and (for product) SplitText.min.js.
 */
(function () {
  'use strict';
  if (window.ElevenTheoryMotion) { window.ElevenTheoryMotion.mount(document); return; }
  var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
  if (!gsap || !ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);
  if (window.SplitText) gsap.registerPlugin(window.SplitText);
  var instances = new Map();
  // Layout body classes style shared chrome; only section wrappers own scenes.
  var selector = '.rugged-home:not(body):not(html),.etm-page:not(body):not(html),.etcf-page:not(body):not(html)';
  var refreshFrame = 0;
  function refresh() {
    if (refreshFrame) return;
    refreshFrame = requestAnimationFrame(function () { refreshFrame = 0; ScrollTrigger.refresh(); });
  }
  function enabled() { return !document.body || document.body.dataset.motion !== 'false'; }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function roots(scope) {
    var found = scope && scope.querySelectorAll ? Array.prototype.slice.call(scope.querySelectorAll(selector)) : [];
    if (scope && scope.matches && scope.matches(selector)) found.unshift(scope);
    return found;
  }
  function enter(elements, offset, duration, threshold) {
    elements.forEach(function (element) {
      gsap.fromTo(element, { y: offset, opacity: 0.35 }, {
        y: 0, opacity: 1, immediateRender: false, duration: duration, ease: 'power3.out',
        scrollTrigger: { trigger: element, start: 'top ' + threshold, once: true }
      });
    });
  }
  function home(root, q) {
    var hero = q('.rug-hero')[0], cover = q('.rug-cover-frame img'), statement = q('.rug-statement')[0], field = q('.rug-field')[0];
    if (hero) {
      gsap.timeline({ defaults: { ease: 'power3.out' } })
        .from(q('.rug-hero-title>span'), { y: 14, stagger: 0.1, duration: 0.7 }, 0)
        .from(q('.rug-hero-copy>p,.rug-hero-copy>.rug-glass'), { y: 10, stagger: 0.08, duration: 0.65 }, 0);
      if (cover.length) gsap.to(cover, { yPercent: 4, scale: 1.04, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.8 } });
    }
    enter(q('[data-rug-reveal]'), 34, 0.9, '90%');
    q('[data-rug-parallax]').forEach(function (image) {
      if (!image.parentElement) return;
      gsap.fromTo(image, { yPercent: -5, scale: 1.12 }, { yPercent: 5, scale: 1, ease: 'none', scrollTrigger: { trigger: image.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1 } });
    });
    if (statement) {
      var words = q('.rug-statement h2 span');
      var endColor = getComputedStyle(statement).color;
      if (words.length) gsap.fromTo(words, { color: '#8f8b82' }, { color: endColor, stagger: 0.12, ease: 'none', scrollTrigger: { trigger: statement, start: 'top 75%', end: 'bottom 48%', scrub: 0.7 } });
    }
    if (field && q('.rug-type-track').length) gsap.to(q('.rug-type-track'), { xPercent: -13, ease: 'none', scrollTrigger: { trigger: field, start: 'top bottom', end: 'bottom top', scrub: 1 } });
  }
  function materials(root, q) {
    var hero = q('.etm-hero')[0];
    if (hero) {
      gsap.timeline({ defaults: { ease: 'power3.out' } })
        .from(q('.etm-hero-art'), { opacity: 0.35, y: 50, rotation: -8, scale: 0.87, duration: 1.5 }, 0.1)
        .from(q('.etm-hero-title span'), { yPercent: 75, opacity: 0.35, duration: 1, stagger: 0.12 }, 0.2)
        .from(q('.etm-hero-copy>.et-kicker,.etm-hero-summary,.etm-hero-link'), { opacity: 0.35, y: 14, duration: 0.85, stagger: 0.12 }, 0.45)
        .from(q('.etm-hero-bottom'), { opacity: 0.35, y: 10, duration: 0.7 }, 0.8);
      gsap.to(q('.etm-hero-art'), { y: 80, rotation: 8, scale: 0.96, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.9 } });
    }
    enter(q('[data-mat-reveal]'), 28, 0.9, '92%');
    q('[data-mat-photo]').forEach(function (image) {
      if (image.parentElement) gsap.fromTo(image, { scale: 1.1 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: image.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1 } });
    });
    var bridge = q('.etm-bridge-words')[0], number = q('.etm-material-number')[0];
    if (bridge) gsap.fromTo(q('.etm-bridge-words span'), { color: '#bcb6aa' }, { color: getComputedStyle(bridge).color, stagger: 0.16, ease: 'none', scrollTrigger: { trigger: bridge, start: 'top 75%', end: 'bottom 45%', scrub: 0.8 } });
    if (number) gsap.fromTo(number, { y: 30, opacity: 0.4 }, { y: 0, opacity: 1, immediateRender: false, duration: 1.2, ease: 'power3.out', scrollTrigger: { trigger: number, start: 'top 95%', once: true } });
  }
  function materialPin(root, q) {
    var grid = q('.etm-comfort-grid')[0], art = q('.etm-comfort-art')[0];
    if (!grid || !art) return;
    gsap.timeline({ scrollTrigger: { trigger: grid, start: 'top 135px', end: 'bottom bottom', pin: art, pinSpacing: false, scrub: 0.8, invalidateOnRefresh: true } })
      .from(q('.etm-layer-contact'), { y: 95, ease: 'none' }, 0)
      .from(q('.etm-layer-spacer'), { y: 60, ease: 'none' }, 0)
      .from(q('.etm-layer-base'), { y: 25, ease: 'none' }, 0);
  }
  function materialIndex(root, q) {
    var links = q('.etm-index a');
    q('.etm-exhibit[id]').forEach(function (exhibit) {
      function select() { links.forEach(function (link) { if (link.hash === '#' + exhibit.id) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); }); }
      ScrollTrigger.create({ trigger: exhibit, start: 'top 45%', end: 'bottom 45%', onEnter: select, onEnterBack: select });
    });
  }
  function carry(root, q) {
    gsap.from(q('[data-cf-enter]'), { y: 32, opacity: 0.35, duration: 1, stagger: 0.1, ease: 'power3.out' });
    enter(q('[data-cf-reveal]'), 28, 0.85, '91%');
    var allocation = q('.etcf-allocation')[0], hero = q('.etcf-hero')[0];
    if (allocation) gsap.fromTo(q('.etcf-allocation-cell'), { opacity: 0.15, scaleY: 0.25 }, { opacity: 1, scaleY: 1, immediateRender: false, transformOrigin: 'bottom', duration: 0.55, stagger: { each: 0.009, from: 'end' }, ease: 'power2.out', scrollTrigger: { trigger: allocation, start: 'top 83%', once: true } });
    if (hero) gsap.to(q('.etcf-hero-number'), { y: 45, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.8 } });
  }
  function locks(root) {
    var releases = [];
    root.querySelectorAll('details.et-lock-shell').forEach(function (details) {
      var summary = details.querySelector('summary'), panel = details.querySelector('.et-lock-panel'), article = details.closest('.et-locked-object');
      if (!summary || !panel) return;
      var tween = null, closing = false;
      function sync() { if (article) article.classList.toggle('is-open', details.open); }
      function clear() { panel.style.removeProperty('height'); panel.style.removeProperty('opacity'); panel.style.removeProperty('overflow'); }
      function click(event) {
        if (!enabled() || reduced()) return;
        event.preventDefault();
        if (tween) tween.kill();
        var opening = !details.open || closing;
        closing = !opening;
        panel.style.overflow = 'hidden';
        if (opening) {
          var wasOpen = details.open;
          details.open = true; sync();
          if (!wasOpen) gsap.set(panel, { height: 0, opacity: 0 });
          tween = gsap.to(panel, { height: 'auto', opacity: 1, duration: 0.4, ease: 'power3.inOut', overwrite: true, onComplete: function () { tween = null; clear(); refresh(); } });
        } else {
          tween = gsap.to(panel, { height: 0, opacity: 0, duration: 0.4, ease: 'power3.inOut', overwrite: true, onComplete: function () { tween = null; closing = false; details.open = false; sync(); clear(); refresh(); } });
        }
      }
      function escape(event) { if (event.key === 'Escape' && details.open) { if (tween) tween.kill(); closing = false; details.open = false; sync(); clear(); summary.focus(); refresh(); } }
      summary.addEventListener('click', click); details.addEventListener('toggle', sync); details.addEventListener('keydown', escape); sync();
      releases.push(function () { if (tween) tween.kill(); clear(); summary.removeEventListener('click', click); details.removeEventListener('toggle', sync); details.removeEventListener('keydown', escape); });
    });
    return function () { releases.forEach(function (release) { release(); }); };
  }
  function init(root) {
    if (instances.has(root)) return;
    var active = true, context = gsap.context(function () {}, root), media = gsap.matchMedia();
    var q = function (query) { return Array.prototype.slice.call(root.querySelectorAll(query)); };
    var releaseLocks = locks(root);
    function dispose() {
      active = false; releaseLocks(); media.revert(); context.revert();
      root.removeEventListener('load', refresh, true); root.removeEventListener('toggle', refresh, true);
      instances.delete(root);
    }
    instances.set(root, dispose);
    try {
      context.add(function () {
        if (root.matches('.etm-page')) materialIndex(root, q);
        if (!enabled()) return;
        media.add('(prefers-reduced-motion: no-preference)', function () {
          if (root.matches('.rugged-home')) home(root, q);
          if (root.matches('.etm-page')) materials(root, q);
          if (root.matches('.etcf-page')) carry(root, q);
        });
        if (root.matches('.etm-page')) media.add('(min-width: 1000px) and (prefers-reduced-motion: no-preference)', function () { materialPin(root, q); });
      });
      root.addEventListener('load', refresh, true); root.addEventListener('toggle', refresh, true);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (active) refresh(); }).catch(function () {});
    } catch (error) {
      dispose();
      console.warn('[Eleven Theory] Scroll motion reverted; page content remains available.', error);
    }
  }
  function mount(scope) { roots(scope).forEach(init); refresh(); }
  function unmount(scope) { instances.forEach(function (dispose, root) { if (scope === root || (scope.contains && scope.contains(root))) dispose(); }); }
  window.ElevenTheoryMotion = { mount: mount, unmount: unmount, refresh: refresh, version: 'html-parity-1' };
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); refresh(); });
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:block:select', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true }); else mount(document);
  document.dispatchEvent(new CustomEvent('et:motion-ready'));
}());
